export const REBUILD_BUDGET = 3;
export const REBUILD_WINDOW_MS = 60_000;

export class RebuildBudget {
  private attempts: number[] = [];

  consume(now = Date.now()) {
    this.attempts = this.attempts.filter((at) => now - at < REBUILD_WINDOW_MS);
    this.attempts.push(now);

    return { allowed: this.attempts.length <= REBUILD_BUDGET, attempt: this.attempts.length };
  }
}
